export default __webpack_public_path__ + "static/media/Waved_secondary-full.55f4eeb7.svg";